import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";

/**
 * Permission checks for PSEA actions, for use with the `Permissions`
 * component. Each action is available either through the main API or through
 * the agency controller, so every list is an OR of the two.
 */
export const PSEA_VIEW_CHECKS = [
  { resource: "psea-assessment", action: "findOne" },
  { resource: "psea-assessment", action: "findOne", controller: "agency" },
];

export const PSEA_CREATE_CHECKS = [
  { resource: "psea-assessment", action: "create" },
  { resource: "psea-assessment", action: "create", controller: "agency" },
];

export const PSEA_UPDATE_CHECKS = [
  { resource: "psea-assessment", action: "update" },
  { resource: "psea-assessment", action: "update", controller: "agency" },
];

/**
 * PSEA "admin" privileges. Holders of the main API `psea-assessment` create
 * permission may choose which agency assessed the contractor. Agency-scoped
 * users are always pinned to their own agency (the agency controller forces
 * it server-side), so the field is shown read-only for them.
 */
export const useIsPseaAdmin = (): boolean => {
  const { userProfile } = useProfile();

  return isAllowed(userProfile?.permissions, [
    { resource: "psea-assessment", action: "create" },
  ]);
};
